/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Confirm_DeclinedInputs */



/**
* | output |
* | --- |
* | "You declined this action." |
*
* @param {Uno_Confirm_DeclinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_declined = /** @type {((inputs?: Uno_Confirm_DeclinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_DeclinedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du hast diese Aktion abgelehnt.")
	return /** @type {LocalizedString} */ ("You declined this action.")
});